import { apiInstance } from '@/api/instance';

/** Contract: bodyprint-api/docs/external-apis/media-partners.md (Partner portal). Aggregates only. */
export interface MediaPartnerKey {
  id: string;
  last4: string;
  createdAt: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

export interface IntegrationActivity {
  mediaReceived: number;
  notificationsDelivered: number;
  galleryClicks: number;
  mediaClicks: number;
}

interface IntegrationStats {
  subjectsAvailable: number;
  last30Days: IntegrationActivity;
  total: IntegrationActivity;
}

type IntegrationApiActivityKind = 'feed_read' | 'media_received' | 'media_rejected';

/** Counters of one hour of API calls: `subjects`/`revoked` for feed reads, `media` for photos. */
interface IntegrationApiActivityCounts {
  requests: number;
  subjects: number;
  revoked: number;
  media: number;
}

/** One line of the "Atividade" list, newest first: an hour of API calls or a key the team managed. */
export type IntegrationLogItem =
  | { kind: IntegrationApiActivityKind; at: string; counts: IntegrationApiActivityCounts }
  | { kind: 'key_created' | 'key_revoked'; at: string; counts: null };

/** `enabled` is false until the Bodyprint team creates the first key for the account. */
export type PartnerIntegrationResponse =
  | { enabled: false; provider: null; keys: []; stats: null; log: [] }
  | {
      enabled: true;
      provider: string | null;
      keys: MediaPartnerKey[];
      stats: IntegrationStats;
      log: IntegrationLogItem[];
    };

export const partnersIntegrationApi = {
  read: () => apiInstance.get<PartnerIntegrationResponse>('partners/integration'),
};

export const partnersIntegrationApiKeys = {
  all: ['integration'] as const,
};
